var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M492 291.5c11.046 0 20-8.954 20-20v-131c0-44.112-35.888-80-80-80H80c-44.112 0-80 35.888-80 80v231c0 44.112 35.888 80 80 80h352c44.112 0 80-35.888 80-80 0-11.046-8.954-20-20-20s-20 8.954-20 20c0 22.056-17.944 40-40 40H80c-22.056 0-40-17.944-40-40V144.738l173.755 108.045c13.029 8.101 27.637 12.152 42.245 12.152 14.608 0 29.216-4.051 42.245-12.152L472 144.738V271.5c0 11.046 8.954 20 20 20zm-214.878-72.686c-13.028 8.101-29.216 8.102-42.244 0L56.689 108.012A39.783 39.783 0 0180 100.5h352a39.784 39.784 0 0123.311 7.513L277.122 218.814z"}));
}

EmailInline.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
